import { useEffect, useState } from "react";

const TABLET_PORTRAIT_QUERY =
  "(pointer: coarse) and (hover: none) and (orientation: portrait) and (min-width: 768px) and (max-width: 1024px)";

/**
 * Returns true when the device is a tablet in portrait orientation.
 * Backed by a single matchMedia listener so it never reacts to the
 * on-screen keyboard opening (visualViewport.resize).
 */
export function useIsTabletPortrait(): boolean {
  const [isTabletPortrait, setIsTabletPortrait] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(TABLET_PORTRAIT_QUERY);
    const update = () => setIsTabletPortrait(mql.matches);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, []);

  return isTabletPortrait;
}
